<script setup lang="ts">
import { injectEventInfoConfig } from '@desktop/views/Relation/Sports/provide-inject'

import EventInfoComponent from './components/EventInfoControl.vue'
import Latency from './components/Latency.vue'
import MatchStatus from './components/MatchStatus.vue'
import NeutralVenue from './components/NeutralVenue.vue'
import OfficialWebsiteLink from './components/OfficialWebsiteLink.vue'
import RelationStatus from './components/RelationStatus.vue'
import StartDate from './components/StartDate.vue'
import { isEventDetailId } from './components/utils'
import Venue from './components/Venue.vue'

const { eventInfoControls } = injectEventInfoConfig()!
</script>

<template>
  <div class="w-110">
    <div class="flex w-full items-center">
      Event info
      <OfficialWebsiteLink />
    </div>
    <div
      class="flex flex-col gap-y-3 pt-4"
      data-testid="event-info-controls"
    >
      <RelationStatus />
      <StartDate />

      <div class="grid grid-cols-2 gap-y-3">
        <MatchStatus />
        <Latency />
        <Venue />
        <NeutralVenue />
      </div>

      <template
        v-for="(item, index) in eventInfoControls"
        :key="index"
      >
        <EventInfoComponent
          v-if="item.control"
          :control="item.control"
        />

        <div
          v-else-if="item.grid"
          class="grid items-center gap-y-3"
          :class="[
            item.grid.class,
            {
              'grid-cols-3': item.grid.cols === '3',
              'grid-cols-2': item.grid.cols === '2',
            },
          ]"
        >
          <EventInfoComponent
            v-for="(control, j) in item.grid.controls"
            :key="j"
            v-bind="
              item.grid.cols === '3' && isEventDetailId(control)
                ? {
                    inputClass: 'w-18',
                  }
                : {}
            "
            :class="{
              'flex justify-end': item.grid.cols === '3' && (j + 1) % 3 === 0,
            }"
            :control
          />
        </div>
      </template>
    </div>
  </div>
</template>
